module.exports = __webpack_public_path__ + "media/assets/transfer/transports/economy.6ebfa495-6ebfa4950659a7675126f8dd45d6ffc4.png";